const list = [
  {
    uuid: 'd1465ad0-9277-4011-80a3-eb6430449298',
    name: 'LnW',
    prefix: 'com.lnw.gcm.',
  },
];

export default { list };
